import * as React from "react";
import AutoLink from "../utils/auto-link";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";

import settings from "../../data/settings.yaml";

function Menu({ items }) {
  return !items ? null : (
    <nav className="col flex-column">
      {items.map((item) => (
        <AutoLink to={item.path} key={item.path} className="w-100 text-truncate nav-link">
          {item.label}
        </AutoLink>
      ))}
    </nav>
  );
}

export default function Footer({ sliceContext }) {
  const year = new Date().getFullYear();
  const menu1 = settings?.footer?.menu?.column1;
  const menu2 = settings?.footer?.menu?.column2;
  const { title, description, legal } = settings?.footer;
  return (
    <div className="bg-white text-muted">
      <div className="container py-3 py-md-5">
        {!title ? null : (
          <div className="row d-none d-sm-block offset-lg-3">
            <h3 className="fs-5 text-muted">{title}</h3>
          </div>
        )}
        <div className="row d-none d-sm-flex mb-2 mb-md-3 mb-lg-5 offset-lg-3">
          {!description ? null : (
            <div className="col col-sm-7 col-md-6 col-lg-5">
              <ReactMarkdown
                components={{ p: React.Fragment }}
                children={settings?.footer?.description}
              />
            </div>
          )}
          <div className="col col-sm-5 offset-lg-1 col-lg-4">
            <div className="row row-cols-2">
              {!menu1 ? null : <Menu items={menu1} />}
              {!menu2 ? null : <Menu items={menu2} />}
            </div>
          </div>
        </div>
        <div className="row small">
          <div className="col offset-lg-3">
            <span className="me-3">
              {legal?.copyright.replace("{year}", year)}
            </span>
            <div className="col d-inline-flex flex-row gap-3 flex-wrap">
              {legal?.menu.map((item) => (
                <AutoLink
                  to={item.path}
                  key={item.path}
                  className="text-decoration-none text-muted"
                >
                  {item.label}
                </AutoLink>
              ))}
              <a
                href="https://bascornelissen.nl/projects/2023/mcg/"
                className="text-decoration-none text-muted d-none d-md-inline opacity-50"
              >
                Built by Bas/Studio Metrum
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
